export default "__VITE_ASSET__MGhUFwlr__"